import { render } from "./MyPageReport.vue?vue&type=template&id=8fd9664a"
import script from "./MyPageReport.vue?vue&type=script&lang=js"
export * from "./MyPageReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__